import React, { useState } from "react";
import styles from "./CashToCredit.module.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Icon } from "@iconify/react";
import {
  getPlayerCash,
  getUsersByID,
  getUserAvailablePromotion,
  getPlayerBalance,
} from "../../store/slices/user";

export default function CashToCredit() {
  const dispatch = useDispatch();
  const { playerCash, singleUsers, userAvailablePromotion } = useSelector(
    (state) => state.user,
  );
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  // Promotion detail
  const promotionDetail = singleUsers?.[0]?.PromotionDetail;
  const promotionStatus = singleUsers?.[0]?.PromotionStatus;
  const promotionID = singleUsers?.[0]?.PromotionID;
  const receivePromo = userAvailablePromotion?.find(
    (item) => item.PromotionID === promotionID,
  );

  // Handle exchange
  const handleExchange = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      let url = promotionDetail
        ? `https://api.pgzone88.com/userbalance/cashtocreditwithpro/${singleUsers?.[0]?.id}`
        : `https://api.pgzone88.com/userbalance/cashtocreditnotpro/${singleUsers?.[0]?.id}`;
      // Use BonusDepMaximum if receivePromo exists
      const cashAmount = receivePromo ? receivePromo.BonusDepMaximum : amount;
      const res = await axios.post(url, { cashAmount });
      if (res?.data?.success) {
        setMsg({ type: "success", text: "รับเครดิตเรียบร้อย" });
        dispatch(getPlayerCash(singleUsers?.[0]?.id));
        dispatch(getUsersByID(singleUsers?.[0]?.id));
        dispatch(getUserAvailablePromotion(singleUsers?.[0]?.id));
        dispatch(getPlayerBalance(singleUsers?.[0]?.id));
      } else {
        setMsg({ type: "error", text: "ไม่สามารถรับเครดิตได้" });
      }
    } catch (err) {
      setMsg({ type: "error", text: "เกิดข้อผิดพลาด กรุณาลองใหม่" });
    }
    setLoading(false);
    setAmount("");
  };

  return (
    <div className={styles.depositWrapper}>
      <div className={styles.depositHeader}>
        <div className={styles.headerIconWrapper}>
          <Icon icon="mdi:swap-horizontal" className={styles.headerIcon} />
        </div>
        <h4 className={styles.headerTitle}>แลกเงินสดเป็นเครดิต</h4>
        <p className={styles.headerSubtitle}>แลกกระเป๋าเงินสดเป็นเครดิตทันที</p>
      </div>
      <div className={`${styles.depositPanel} ${styles.card}`}>
        <div className={styles.balanceBox}>
          <Icon icon="mdi:wallet" />
          <span style={{ color: "black" }}>
            เงินสดในกระเป๋า:{" "}
            <b className={styles.balanceAmount}>{playerCash} บาท</b>
          </span>
        </div>
        {promotionDetail && (
          <div className={styles.promoCard}>
            <div className={styles.promoGlow} />
            <div className={styles.promoHeader}>
              <div className={styles.promoIcon}>
                <Icon icon="mdi:gift" />
              </div>
              <div className={styles.promoContent}>
                <div className={styles.promoLabel}>โปรโมชั่นที่เลือก</div>
                <div className={styles.promoTitle}>{promotionDetail}</div>
                {promotionStatus === "ACTIVE" && (
                  <span className={styles.promoBadge}>กำลังใช้งาน</span>
                )}
              </div>
            </div>
            <div className={styles.promoNote}>
              💡 กรุณาฝากตามเงื่อนไขโปรโมชั่นเพื่อรับโบนัส
            </div>
          </div>
        )}
        {receivePromo && (
          <div className={styles.recommendCard}>
            <div className={styles.recommendGlow} />
            <div className={styles.recommendHeader}>
              <div className={styles.recommendIcon}>
                <Icon icon="mdi:information-outline" />
              </div>
              <div className={styles.recommendContent}>
                <div className={styles.recommendLabel}>
                  จำนวนเงินที่แนะนำในการฝาก
                </div>
                <div className={styles.recommendAmount}>
                  ฿{receivePromo.BonusDepMaximum.toLocaleString()}
                </div>
                <div className={styles.recommendNote}>
                  ระบบจะใช้ยอดนี้ในการคำนวณโบนัสตามเงื่อนไขโปรโมชั่น
                </div>
              </div>
            </div>
          </div>
        )}

        <form className={styles.depositForm} onSubmit={handleExchange}>
          <div className={styles.depositInputRow}>
            <input
              type="number"
              min="1"
              className={styles.depositInput}
              placeholder={
                receivePromo
                  ? `จำนวนเงินจากโปรโมชัน: ${receivePromo.BonusDepMaximum} บาท`
                  : "กรอกจำนวนเงินที่ต้องการแลก"
              }
              value={receivePromo ? receivePromo.BonusDepMaximum : amount}
              onChange={(e) => setAmount(e.target.value)}
              disabled={
                loading || promotionStatus === "ACTIVE" || !!receivePromo
              }
              required
            />
            <button
              type="submit"
              className={styles.depositBtn + " " + styles.depositBtnMobile}
              disabled={
                loading ||
                promotionStatus === "ACTIVE" ||
                (!!receivePromo && !receivePromo.BonusDepMaximum)
              }
            >
              {loading ? "กำลังแลก..." : "แลกเครดิต"}
            </button>
          </div>
        </form>

        {promotionStatus === "ACTIVE" && (
          <div className={styles.warningBox}>
            <Icon icon="mdi:alert" className={styles.warningIcon} />
            <span>
              ท่านอยู่ระหว่างรับโปรโมชั่น โปรดเคลียร์เทิร์นก่อนแลกเครดิต
            </span>
          </div>
        )}
        {msg && (
          <div
            className={
              msg.type === "success" ? styles.successMsg : styles.errorMsg
            }
          >
            {msg.text}
          </div>
        )}
      </div>
    </div>
  );
}
